import { NavLink } from "react-router-dom";

/**
 * Item navigasi sidebar — mengikuti spesifikasi .navitem Design System KLH/BPLH v2.1
 * (App Shell T5): teks putih opacity .78, radius 8px, aktif = latar --g-600 + elevasi 1.
 * Tinggi minimum 44px sesuai aturan target sentuh DS.
 *
 * Prop `className` dipakai pemanggil untuk indentasi level (pl-4 / pl-8 / pl-12);
 * utility pl-* menang atas px-* di urutan keluaran Tailwind, jadi indentasi tetap utuh.
 */
export default function ListItem({ title, icon, url = "#", className, isDisabled = false }) {
  const base =
    "flex items-center gap-[11px] min-h-[44px] px-3 py-2.5 rounded-ds-sm text-[13.5px] font-medium transition-colors";

  if (isDisabled) {
    return (
      <li>
        <div aria-disabled="true" className={`${base} ${className} text-white/35 cursor-not-allowed`}>
          <div className="flex-shrink-0">{icon}</div>
          <span>{title}</span>
        </div>
      </li>
    );
  }

  return (
    <li>
      <NavLink
        to={url}
        className={({ isActive }) =>
          `${base} ${className} ${
            isActive
              ? "bg-g-600 text-white shadow-ds-1"
              : "text-white/80 hover:bg-white/10 hover:text-white"
          }`
        }
      >
        <div className="flex-shrink-0">{icon}</div>
        <span>{title}</span>
      </NavLink>
    </li>
  );
}
